import React, { useState, useMemo, useEffect } from "react";
import "./App.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import { useStateContext } from "contexts/ContextProvider";
import { ScrollArea } from "components/ui/scroll-area";
import "./animations.css";
import Sidebar from "components/navigation/SideBar";

// import { Dashboard } from "./pages/Dashboard";
import {
  Dashboard,
  Login,
  ForgotPassword,
  ForgotPasswordReset,
  Register,
  ProfileSetup,
  
} from "./pages";
import SetupProfile from "components/authentication/SetupProfile";
import NavBar from "components/navigation/NavBar";
import DarkmodeButton from "./components/ui/DarkmodeButton"; 
import { VerifyEmailMsg, VerifyEmail } from "./components";
import { useAuth } from "contexts/AuthContext";
import ProtectedRoute from "components/authentication/ProtectedRoute"; 
import Tutorial from "components/navigation/Tutorial";
import MobileWateringManager from "components/widgets/queue/MobileWateringManager";
import { brandPageTitle, useBrand } from "contexts/BrandContext";
import { getVerificationCode } from "helpers/verificationCode";

const PublicAuthenticationShell = ({ children }) => (
  <div className="app bg-gray-50 grid-cols-1 dark:bg-gray-1000">
    <div className="absolute top-3 right-3">
      <DarkmodeButton />
    </div>
    <main className="w-full h-full sm:min-h-0 relative">
      <ScrollArea orientation="vertical" className="h-full w-full max-h-[calc(100%_-_0rem)]">
        <div className="p-4 flex items-center justify-center flex-col w-full h-full min-h-svh">
          {children}
        </div>
      </ScrollArea>
    </main>
  </div>
);

const isPasswordSetupPath = (pathname) => pathname === "/password-reset" || pathname === "/set-password";

const AppRouter = () => {
  const { pathname } = useLocation();

  // Invitation/password setup must stay outside the signed-in application.
  // Do not clear the existing browser session: a recipient may open the link
  // in a browser that is currently signed in as somebody else.
  if (isPasswordSetupPath(pathname)) {
    return <PublicAuthenticationShell><ForgotPasswordReset /></PublicAuthenticationShell>;
  }

  // The setup page links here explicitly so an existing session cannot put
  // the login form back inside the current user's dashboard shell.
  if (pathname === "/login") {
    return <PublicAuthenticationShell><Login /></PublicAuthenticationShell>;
  }

  return <AppContent />;
};

const AppContent = ({ isMapRoute }) => {
  const [isSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const { userProfile, activeComponent, setActiveComponent, activeLinkName } = useStateContext();
  const { isAuthenticated, isLoading } = useAuth();
  const { brand } = useBrand();

  const [resToken, setResToken] = useState(null);
  const [verToken, setVerToken] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const passwordPath = isPasswordSetupPath(window.location.pathname);
    const resetToken = queryParams.get('resToken') || queryParams.get('resetToken') || (passwordPath ? queryParams.get('token') : null);
    const verify = getVerificationCode(window.location.search);

    if (resetToken) {
      setResToken(resetToken);
    }

    if (verify) {
      setVerToken(verify);
    }
  }, []);

  useEffect(() => {
    document.title = brandPageTitle(brand.brandName, activeComponent);
  }, [activeComponent, brand.brandName]);

  /*useEffect(() => {
    console.log("Navigation useEffect called");
    //Retrieve the saved path from local storage
    if (isAuthenticated) {
      const savedPath = localStorage.getItem('currentPath');
      if (savedPath && savedPath !== location.pathname) {
        navigate(savedPath, { replace: true });
      }
    }
  }, [isAuthenticated]);*/

  /*useEffect(() => {
    // Save the current path to local storage only when it changes
    if (isAuthenticated) {
      localStorage.setItem('currentPath', location.pathname); //Save in sessionStorage?
    }
  }, [location.pathname]);*/

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isSidebarOpen);
  };

  useMemo(() => {
    
  }, [isSidebarOpen]);

  useMemo(() => {
    const className = 'dark';
    const element = document.documentElement;
    const metaThemeColor = document.querySelector("meta[name=theme-color]");
    switch (userProfile.userSettings.darkMode) {
      case 'dark':
        element.classList.add(className);
        metaThemeColor.setAttribute('content', "#111111");
        break;
      case 'light':
        element.classList.remove(className);
        metaThemeColor.setAttribute('content', "#F6F6F6");
        break;
      case 'system':
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          element.classList.add(className);
        } else {
          element.classList.remove(className);
        }
        break;
      default:
        break;
    }
  }, [userProfile.userSettings.darkMode]);


  useMemo(() => {
    // Apply the font size setting globally
    const fontSize = userProfile.userSettings.fontSize || '16px'; // Default to 16px if not set
    document.documentElement.style.setProperty('--user-font-size', fontSize);
  }, [userProfile.userSettings.fontSize]);




 
  const [showTutorial, setShowTutorial] = useState(false);

  const temporaryIsAuthenticated = false; 

  useMemo(() => {
    const expandNavButton = document.getElementById("expandNavButton");
    if (expandNavButton) {
      expandNavButton.classList.toggle(
        "-scale-x-1",
        userProfile.userSettings.sidebarPosition === "right"
      );
    }
  }, [userProfile.userSettings.sidebarPosition]);

  if (isLoading) {
    return <div>Loading...</div>;
  }


  
  // const componentMappings = {
  //   dashboard: Dashboard, analytics: Analytics, maps: Maps, reports: Reports, events: Events, community: Community,
  //   devices: Devices, profile: Profile, notifications: Notifications, profileSetup: ProfileSetup, calendar: Calendar, chat: Chat, help: Help,
  //   settings: Settings, login: Login, forgotPassword: ForgotPassword, forgotPasswordReset: ForgotPasswordReset, register: Register,
  //   verifyEmail: VerifyEmail, verifyEmailMsg: VerifyEmailMsg, setupProfile: SetupProfile,
  // };
  const componentMappings = {
     
    dashboard: Dashboard,
    profileSetup: ProfileSetup,
    login: Login, forgotPassword: ForgotPassword, forgotPasswordReset: ForgotPasswordReset, register: Register,
    verifyEmail: VerifyEmail, verifyEmailMsg: VerifyEmailMsg, setupProfile: SetupProfile,
  };

  const authComponentMappings = {
    login: Login, forgotPassword: ForgotPassword, forgotPasswordReset: ForgotPasswordReset, register: Register,
    verifyEmail: VerifyEmail, verifyEmailMsg: VerifyEmailMsg, setupProfile: SetupProfile, profileSetup: ProfileSetup,
  };

  const renderComponent = () => {
    /*if (!isAuthenticated && !temporaryIsAuthenticated) {
      return <Login />;
    }*/

    if (resToken) {
      return <ForgotPasswordReset token={resToken} />;
    }

    if (verToken) {
      return <VerifyEmail token={verToken} />;
    }

    if (!isAuthenticated && !temporaryIsAuthenticated) {
      const Component = authComponentMappings[activeComponent] || Login;
      return <Component />;
    }
    const Component = componentMappings[activeComponent] || Dashboard;


    const isProtected = !['login', 'forgotPassword', 'forgotPasswordReset', 'register', 'verifyEmail', 'verifyEmailMsg', 'setupProfile', 'profileSetup'].includes(activeComponent);
    return isProtected ? (
      <ProtectedRoute activeComponent={activeComponent}>
        <Component />
      </ProtectedRoute>
    ) : (
      <Component />
    );
  };
  return (
    // <PageTitleProvider>



    <div className={`app bg-gray-50  ${userProfile.userSettings.sidebarPosition === "right" ? 'grid-cols-[1fr_auto]' : 'grid-cols-[auto,_1fr]'} dark:bg-gray-1000 `}>
      <Tutorial showTutorial={showTutorial} setShowTutorial={setShowTutorial} ></Tutorial>
      {/**<BrowserRouter>**/}
      {isAuthenticated || temporaryIsAuthenticated ? (
        <>
          <Sidebar
            sidebarPosition={userProfile.userSettings.sidebarPosition}
            isSidebarOpen={isSidebarOpen}
            setIsMobileSidebarOpen={setIsMobileSidebarOpen}
            toggleMobileSidebar={toggleMobileSidebar}
            setActiveComponent={setActiveComponent}
            activeComponent={activeComponent}
          />
          <div className={`main-content max-h-screen ${userProfile.userSettings.sidebarPosition === "right" && 'row-start-1 col-start-1'} grid grid-rows-[auto,_1fr] `}>
            <NavBar toggleMobileSidebar={toggleMobileSidebar} />
            {/**setActiveComponent={setActiveComponent} activeComponent={activeComponent} */}
            <main
              className={`w-full h-[calc(100svh_-_56px)] sm:min-h-0 sm:h-[calc(100svh_-_56px)] ro w-span-2 sm:overflow-clip relative`}>
              <div className=" flex flex-col h-full custom-scrollbar">
                {showTutorial && (
                  <div className="w-full fixed -top-20 inset-0 z-30 h-f ull bg-gray-900/20 backdrop-bl ur-lg bg-gra y-100/50  dark:bg-gr ay-950/50">
                  </div>

                )}
                {/* <MobileWateringManager /> */}

                {renderComponent()}

              </div>
            </main>
          </div>
        </>
      ) : (
        <div
          className={`main-content grid grid-rows-[auto,_1fr] col-span-2`}>
          <div className="absolute top-3 right-3">
            <DarkmodeButton />
          </div>
          <main
            className={`w-full h-full  sm:min-h-0 row-span-2 relative`}>
            <ScrollArea orientation="vertical" className=" h-full w-full max-h-[calc(100%_-_0rem)] ">
              <div className="p-4 flex items-center justify-center flex-col w-full h-full min-h-svh">

                {renderComponent()}
              </div>
            </ScrollArea>

          </main>
        </div>
      )}
      {/**</BrowserRouter>**/}

      {/**<IframePortal />**/} {/* This places the MapGis permanently in the DOM, managed by routes via context */}
    </div>
    
  );
};

const App = () => (
  <BrowserRouter>
    <AppRouter />
  </BrowserRouter>

);

export default App;
